var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.375C10.5 18.1429 10.5922 17.9204 10.7563 17.7563C10.9204 17.5922 11.1429 17.5 11.375 17.5H16.625C16.8571 17.5 17.0796 17.5922 17.2437 17.7563C17.4078 17.9204 17.5 18.1429 17.5 18.375C17.5 18.6071 17.4078 18.8296 17.2437 18.9937C17.0796 19.1578 16.8571 19.25 16.625 19.25H11.375C11.1429 19.25 10.9204 19.1578 10.7563 18.9937C10.5922 18.8296 10.5 18.6071 10.5 18.375ZM7 13.125C7 12.8929 7.09219 12.6704 7.25628 12.5063C7.42038 12.3422 7.64294 12.25 7.875 12.25H20.125C20.3571 12.25 20.5796 12.3422 20.7437 12.5063C20.9078 12.6704 21 12.8929 21 13.125C21 13.3571 20.9078 13.5796 20.7437 13.7437C20.5796 13.9078 20.3571 14 20.125 14H7.875C7.64294 14 7.42038 13.9078 7.25628 13.7437C7.09219 13.5796 7 13.3571 7 13.125ZM3.5 7.875C3.5 7.64294 3.59219 7.42038 3.75628 7.25628C3.92038 7.09219 4.14294 7 4.375 7H23.625C23.8571 7 24.0796 7.09219 24.2437 7.25628C24.4078 7.42038 24.5 7.64294 24.5 7.875C24.5 8.10706 24.4078 8.32962 24.2437 8.49372C24.0796 8.65781 23.8571 8.75 23.625 8.75H4.375C4.14294 8.75 3.92038 8.65781 3.75628 8.49372C3.59219 8.32962 3.5 8.10706 3.5 7.875Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.eb687b2c7223244dfa54e3b9c4931a90.svg";
export { ForwardRef as ReactComponent };